import React from "react";
require('@csn-theme/editors-rating');

function ArticleMedia(props) {
    var classes = ((props.classes || "") + " article-media").trim();

    return (
        <div className={classes}>
            {props.numPhotos > 0 && <span><i className="icon-camera"></i>{props.numPhotos}</span>}
            {props.numVideos > 0 && <span><i className="icon-video"></i>{props.numVideos}</span>}
        </div>
    );
}

function ArticleType(props) {
    var classes = props.type && props.type.toLowerCase().split(" ").join("-");

    return (<span className={classes}>{props.type}</span>);
}

function EditorsRating(props) {
    if (props.rating <= 0) return (<span></span>);
    return (<span className="editors-rating"><editors-rating value={props.rating} max-value={props.maxRating} show-max-value="false"></editors-rating></span>);
}

function Article(props) {
    const sizeClass = props.isBig ? "col-6" : "col-3";
    if (props.type === "empty") return (<div className={sizeClass}></div>);

    var imgSrc = props.photo ? `${props.photo}?width=480&height=320&pxc_method=crop` : "";
    var imgClasses = "card-img-top";
    if (props.numVideos > 0) {
        imgClasses += " video-overlay";
        if (props.isBig) imgClasses += " big";
    }
    var classes = `card-slider-item ${sizeClass}`;

    var titleClass = `card-title ${props.rating > 0 ? "narrow" : ""}`;

    var showFooterLink = props.footerLinkText && props.footerLinkUrl;

    var title = (<h5 className={titleClass} title={props.fullHeadline}>{props.headline}</h5>);
    var date = (<div className="card-date">{props.footer}</div>);
    var footerLink = (<a href={props.footerLinkUrl} target="_blank">{props.footerLinkText}</a>);
    var body = props.isBig
        ? (<div className="card-body">
            {props.isSponsored && 
                <div className="card-body-row">
                    <span className="card-sponsored-label-big text-white">Sponsored</span>
                </div>}
            {title}
            <div className="card-body-row">
                {<ArticleType {...props}></ArticleType>}
                {date}
                {<ArticleMedia classes="right" {...props}></ArticleMedia>}
            </div>
        </div>)
        : (<div className="card-body">
            <div className="card-body-row fixed-line-ht">
                {<ArticleType {...props}></ArticleType>}
                {<ArticleMedia {...props}></ArticleMedia>}
                {<EditorsRating {...props}></EditorsRating>}
            </div>
            {title}
            {date}
            {showFooterLink && footerLink}
        </div>);

    return (
        <div className={classes}>
            <a className="card text-body" href={props.detailsUrl} data-webm-clickvalue={props.clickValue}>
                <div className={imgClasses}>
                    <img src={imgSrc} alt={`${props.fullHeadline} image`} />  
                    {props.isSponsored && !props.isBig && <span className="card-sponsored-label text-white">Sponsored</span>}                  
                </div>
                {body}
            </a>
        </div>
    );
}

class Section extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            offset: 0,
            animating: false,
            animateTarget: 0
        };
        this.numSlides = Math.ceil(props.articles.length / props.cardsPerSlide);
        this.animationDuration = 500;

        this.changeOffset = this.changeOffset.bind(this);
        this.setOffset = this.setOffset.bind(this);
    }

    changeOffset(amount) {
        if (this.state.animating || this.numSlides === 1) return;
        this.setState({ animating: true, animateTarget: amount });
        setTimeout(() => {
            this.setState(oldState => {
                var newOffset = (oldState.offset + amount) % this.numSlides;
                if (newOffset < 0) newOffset = this.numSlides + newOffset;
                return { offset: newOffset, animating: false, animateTarget: 0 };
            });
        }, this.animationDuration);
    }

    setOffset(val) {
        if (this.state.animating || this.numSlides === 1) return;
        this.setState(oldState => ({ animating: true, animateTarget: val - oldState.offset }));
        setTimeout(() => this.setState({ offset: val, animating: false, animateTarget: 0 }), this.animationDuration);
    }

    getArticles() {
        var cardsPerSlide = this.props.cardsPerSlide;
        var offset = this.state.offset * cardsPerSlide;
        if(this.props.articles.length % this.props.cardsPerSlide != 0){
            this.props.articles.push(...new Array(this.numSlides * this.props.cardsPerSlide - this.props.articles.length).fill()
            .map((_, i) => ({ id: `empty-${i}`, type: "empty" })));
        }
        var previousSlide = this.props.articles.slice(offset).concat(this.props.articles.slice(0, offset)).slice(-cardsPerSlide * (this.state.offset + 1));
        var currentSlide = this.props.articles.slice(offset, offset + cardsPerSlide);
        var nextSlide = this.props.articles.slice(offset + cardsPerSlide).concat(this.props.articles.slice(0, offset)).slice(0, cardsPerSlide * (this.numSlides - this.state.offset));
        return [].concat(previousSlide, currentSlide, nextSlide);
    }

    mapArticles(articles) {
        var idCache = {};
        var isBig = this.props.cardsPerSlide <= 2;

        return articles.map(articleData => {
            var numDupes = idCache[articleData.id];
            idCache[articleData.id] = numDupes ? ++numDupes : 1;
            var clickValue = `${this.props.name}-tile-${this.props.articles.indexOf(articleData) + 1}`
            return (<Article key={`${articleData.id}-${numDupes}`} isBig={isBig} clickValue={clickValue} {...articleData}></Article>);
        });
    }

    getLocations() {
        var selectIndex = (this.state.offset + this.state.animateTarget) % this.numSlides;
        if (selectIndex < 0) selectIndex = this.numSlides + selectIndex;

        return new Array(this.numSlides).fill(null).map((_, i) => {
            var classes = "slider-location-node";
            if (i === selectIndex) classes += " selected";

            return (
                <span key={`location-${i}`} className={classes} onClick={() => this.setOffset(i)}>
                    <span className={i === selectIndex ? "bg-primary" : ""}></span>
                </span>
            );
        });
    }

    render() {
        var showAll = this.props.showAllText && this.props.showAllUrl && this.props.showAllText.length && this.props.showAllUrl.length;
        var articles = this.mapArticles(this.getArticles());
        var sliderStyle = { transform: `translateX(${-100 * this.state.animateTarget - 100 * this.state.offset - 100}%)` };
        if (this.state.animateTarget) sliderStyle["transition"] = `transform ${this.animationDuration}ms ease 0s`;
        var id = `editorial-${(this.props.title || "").toLowerCase().split(" ").join("-")}`;

        return (
            <div className="editorial-section" id={id}>
                <div className="editorial-header">
                    <h4>{this.props.title}</h4>
                    {showAll &&
                        <a className="text-primary" href={this.props.showAllUrl} data-webm-clickvalue={`homepage-${this.props.name}-all`}>
                            {this.props.showAllText}
                            <i className="icon-arrow-right"></i>
                        </a>}
                </div>

                <div className="card-slider">
                    <div className="card-slider-prev text-primary" onClick={() => this.changeOffset(-1)}></div>
                    <div className="slider-wrapper">
                        <div style={sliderStyle}>
                            <div className="card-slider-inner">
                                {articles}
                            </div>
                        </div>
                    </div>
                    <div className="card-slider-next text-primary" onClick={() => this.changeOffset(1)}></div>
                    <div className="slider-location">
                        {this.getLocations()}
                    </div>
                </div>
            </div>
        );
    }
}

export default class EditorialComponent extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        var sections = this.props.sections
            .filter(s => s && s.articles && s.articles.length)
            .map(sectionData => (<Section key={sectionData.name} {...sectionData}></Section>));
        var showHeader = this.props.title;

        return (
            <div className="editorial" data-webm-section="editorial-homepage-module">
                {showHeader && <div className="editorial-header">
                    <h2>{this.props.title}</h2>
                    {this.props.editorialUrl && this.props.editorialText &&
                        <a className="btn btn-primary" href={this.props.editorialUrl} data-webm-clickvalue={this.props.editorialClickValue}>
                            {this.props.editorialText}
                        </a>
                    }
                </div>}
                {sections}
            </div>
        );
    }
}
